import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";

import Details from "./solution/details";
import PieHolder from "./solution/pieHolder";
import LineChartHolder from "./solution/lineChartHolder";
import BarChartHolder from "./solution/barChartHolder";

import Spinner from "../../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import Button from "../../parts/pdfmaker/common/Button";
import moneyFormatter from "../../common/moneyFormatter";
import WithCard from "../../common/withCard";

import SolutionHelper from "./solution/solution.helper";
import AccumulationHelper from "./accumulation.helper";

import PDFHelper from "../../parts/pdfmaker/pdf.helper";
import PdfHeader from "../../parts/pdfmaker/common/pdfHeader";
import PDFTable from "../../parts/pdfmaker/common/pdfTable";
import {
  Document,
  Page,
  View,
  Text,
  Image as IMG,
  pdf,
  StyleSheet
} from "@react-pdf/renderer";

import "./solution.scss";

class Solution extends Component {
  state = {
    getBacktest: [],
    getPerfHistMetrics: [],
    getRiskStatistics: [],
    spinner: true,
    newData: [],
    columns: [
      { title: "Symbol" },
      { title: "Name" },
      { title: "Asset Class" },
      { title: "Weight(%)" }
    ],
    downloadPDF: false,
    acc_data: [],
    table_data: [],
    table_column: [
      { title: "Year" },
      { title: "Investment" },
      { title: "Returns" },
      { title: "Fund" },
      { title: "Balance" }
    ],
    dec_columns: [
      { title: "Year" },
      { title: "Social Security" },
      { title: "IRA" },
      { title: "Investment Source" },
      { title: "Other Income" },
      { title: "withdraw from Savings" },
      { title: "Shortfall" },
      { title: "Balance" }
    ],
    investMentGlidePath: [],
    dec_pdfTable: this.props.dec_pdfTable,
    depletionFinalValue: this.props.dec_barchartData.length
      ? this.props.dec_barchartData[this.props.dec_barchartData.length - 1][
          "Savings"
        ]
      : 0,
    groupBarWithLineLabels: []
  };

  async componentDidMount() {
    // accumulation barchart data calculation
    const {
      id,
      retirementAge,
      currentSavings,
      possibleAnnualSavings,
      acc_selectedPortfolio,
      currentAge,
      fundList
    } = this.props;

    let acc_data = [];
    let table_data = [];

    let year = new Date().getFullYear();

    for (let i = 0; i <= retirementAge - currentAge; i++) {
      var acc_obj = {};
      var acc_table = [];
      var cal =
        AccumulationHelper.estimatedSavings(
          currentSavings,
          possibleAnnualSavings,
          acc_selectedPortfolio,
          i
        ) *
          1 -
        AccumulationHelper.estimatedSavings(
          currentSavings,
          possibleAnnualSavings,
          acc_selectedPortfolio,
          i - 1
        ) *
          1 -
        possibleAnnualSavings;

      var interest_gained = i !== 0 ? +cal.toFixed(2) : 0;

      let yrs = (year * 1 + i).toString();
      let invest =
        AccumulationHelper.estimatedSavings(
          currentSavings,
          possibleAnnualSavings,
          acc_selectedPortfolio,
          i
        ) * (1).toFixed(2);

      acc_obj["metric_name"] = yrs;
      acc_obj["investment"] = +invest;

      acc_data.push(acc_obj);
      // pdf table data
      acc_table.push((year * 1 + i).toString());
      acc_table.push((invest - interest_gained).toFixed(2));
      acc_table.push(interest_gained);
      acc_table.push(`${acc_selectedPortfolio}%`);
      acc_table.push(invest);

      table_data.push(acc_table);
    }

    let activeTable =
      this.props.activeGlidePath == true
        ? AccumulationHelper.glidePathTableData(
            retirementAge - currentAge,
            currentSavings,
            possibleAnnualSavings,
            fundList[0],
            fundList[1],
            fundList[2]
          )
        : table_data;

    this.setState({
      acc_data,
      table_data: activeTable
    });
    await BacktestService.getBacktest(
      `${id}`,
      `${"MSCI_AGG_20_80"}`,
      `${"LIVE"}`
    ).then(res => {
      if (res) {
        let props = { getBacktest: res };
        var data = SolutionHelper.pieTableHelper(props);
        let temp = data[0];

        let filteredData = [];
        for (let i = 0; i < temp.length; i++) {
          let x = temp[i].slice(0, 4);
          filteredData.push(x);
        }

        this.setState({
          getBacktest: res,
          spinner: false,
          newData: filteredData
        });
      }
    });

    await BacktestService.getRiskStatistics(`${id}`, `${"LIVE"}`).then(res => {
      if (res) {
        this.setState({
          getRiskStatistics: res
        });
      }
    });

    await BacktestService.getPerfHistMetrics(`${id}`, `${"LIVE"}`).then(res => {
      if (res) {
        this.setState({
          getPerfHistMetrics: res
        });
      }
    });

    // group bar with line data
    let end_year = retirementAge - currentAge;
    let investMentGlidePath = AccumulationHelper.glidePathDataCalc(
      end_year,
      currentSavings,
      possibleAnnualSavings,
      fundList[0],
      fundList[1],
      fundList[2]
    );

    let groupBarWithLineLabels = [
      `Moderate (${(fundList[2] * 100).toFixed(2)}%)`,
      `Conservative (${(fundList[1] * 100).toFixed(2)}%)`,
      `Capital Protection (${(fundList[0] * 100).toFixed(2)}%)`
    ];

    this.setState({
      investMentGlidePath,
      groupBarWithLineLabels
    });
  }

  exportPDF = e => {
    e.preventDefault();
    this.setState({
      downloadPDF: true
    });
    const {
      selectedPlan,
      savings,
      income,
      rate,
      fundName,
      id,
      currentSavings,
      possibleAnnualSavings,
      annualIncomeNeeded,
      possibleAnnualIRA,
      retirementAccount,
      acc_selectedPortfolio,
      activeGlidePath,
      acc_fundName
    } = this.props;

    let accumulation_list =
      id !== 999
        ? [
            PDFHelper.svgToPng("rig_barchart01"),
            PDFHelper.svgToPng("rig_barchart02"),
            PDFHelper.svgToPng("Pie99"),
            PDFHelper.svgToPng("retire_lineChart_01")
          ]
        : [
            PDFHelper.svgToPng("rig_barchart01"),
            PDFHelper.svgToPng("rig_barchart02")
          ];
    let decumulation_list =
      id !== 999
        ? [
            PDFHelper.svgToPng("rig_barchart01"),
            PDFHelper.svgToPng("Pie99"),
            PDFHelper.svgToPng("retire_lineChart_01")
          ]
        : [PDFHelper.svgToPng("rig_barchart01")];
    let list =
      selectedPlan === "accumulation" ? accumulation_list : decumulation_list;

    Promise.all([...list]).then(values => {
      const styles = StyleSheet.create({
        page: {
          paddingBottom: 65,
          color: "#696969"
        },
        paddingHorizontal: {
          paddingHorizontal: 35
        },
        small: {
          fontSize: 6
        },
        text: {
          color: "#223279",
          textAlign: "center",
          paddingVertical: 5
        },
        textHeading: {
          color: "#223279",
          textAlign: "center",
          paddingVertical: 5
        },
        detail: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingVertical: 30
        },
        flex_one: {
          flex: 1,
          textAlign: "center"
        },
        flex_two: {
          flex: 2,
          textAlign: "center"
        },
        detail2: {
          width: "50%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingVertical: 10
        }
      });

      const { depletionFinalValue } = this.state;

      const MyDoc = () => (
        <Document>
          {selectedPlan === "accumulation" ? (
            <Page size="A4" wrap style={styles.page}>
              <PdfHeader mainHeading={"RETIREMENT PLANNER"} />
              <View style={styles.paddingHorizontal}>
                {selectedPlan === "accumulation" ? (
                  <Fragment>
                    <View style={styles.text}>
                      <Text>ACCUMULATION</Text>
                    </View>
                    <View style={styles.detail}>
                      <View style={styles.flex_two}>
                        <Text>
                          {moneyFormatter(+currentSavings.toFixed(), false)}
                        </Text>
                        <Text style={styles.small}>CURRENT SAVINGS</Text>
                      </View>
                      <View style={styles.flex_two}>
                        <Text>
                          {moneyFormatter(possibleAnnualSavings, false)}
                        </Text>
                        <Text style={styles.small}>ANNUAL ADDITION</Text>
                      </View>
                      <View style={styles.flex_two}>
                        <Text>{moneyFormatter(annualIncomeNeeded, false)}</Text>
                        <Text style={styles.small}>
                          ANNUAL RETIREMENT INCOME NEEDED
                        </Text>
                      </View>
                      {!activeGlidePath ? (
                        <View style={styles.flex_one}>
                          <Text>{acc_selectedPortfolio.toFixed(2)}%</Text>
                          <Text style={styles.small}>GROWTH RATE</Text>
                        </View>
                      ) : (
                        <View style={styles.flex_one}>
                          <Text>-</Text>
                          <Text style={styles.small}>GLIDE PATH</Text>
                        </View>
                      )}
                      <View style={styles.flex_one}>
                        <Text>
                          {/* possibleAnnualIRA */}
                          {retirementAccount == 0
                            ? retirementAccount
                            : moneyFormatter(
                                retirementAccount.toFixed(),
                                false
                              )}
                        </Text>
                        <Text style={styles.small}>IRA CONTRIBUTION</Text>
                      </View>
                      <View style={styles.flex_two}>
                        <Text>{moneyFormatter(+savings.toFixed(), false)}</Text>
                        <Text style={styles.small}>RETIREMENT SAVINGS</Text>
                      </View>
                    </View>
                    <View style={styles.textHeading}>
                      <Text>YOY ACCUMULATION</Text>
                      {!activeGlidePath ? (
                        <Text style={{ fontSize: "10" }}>
                          SELECTED PORTFOLIO - {acc_fundName}(
                          {acc_selectedPortfolio.toFixed(2)}%)
                        </Text>
                      ) : null}
                    </View>
                    <View>
                      <IMG source={values[1]}></IMG>
                    </View>
                    <View>
                      <PDFTable
                        data={this.state.table_data}
                        heading={this.state.table_column}
                        Width={"20%"}
                      />
                    </View>
                  </Fragment>
                ) : null}
              </View>
            </Page>
          ) : null}

          <Page size="A4" wrap style={styles.page}>
            {selectedPlan === "decumulation" ? (
              <PdfHeader mainHeading={"RETIREMENT PLANNER"} />
            ) : null}
            <View style={styles.paddingHorizontal}>
              <View style={styles.text}>
                <Text>DECUMULATION</Text>
              </View>
              <View style={styles.detail}>
                <View style={styles.flex_two}>
                  <Text>{moneyFormatter(+savings.toFixed(), false)}</Text>
                  <Text style={styles.small}>CURRENT SAVINGS</Text>
                </View>
                <View style={styles.flex_two}>
                  <Text>{moneyFormatter(income * 1000, false)}</Text>
                  <Text style={styles.small}>
                    INCOME FROM SOCIAL SECURITY & OTHER SOURCES
                  </Text>
                </View>
                <View style={styles.flex_one}>
                  <Text>{rate.toFixed(2)}%</Text>
                  <Text style={styles.small}>GROWTH RATE</Text>
                </View>
                <View style={styles.flex_one}>
                  <Text>
                    {retirementAccount == 0
                      ? retirementAccount
                      : moneyFormatter((+retirementAccount).toFixed(), false)}
                  </Text>
                  <Text style={styles.small}>IRA CONTRIBUTION</Text>
                </View>
                <View style={styles.flex_two}>
                  <Text>
                    {moneyFormatter(+depletionFinalValue.toFixed(), false)}
                  </Text>
                  <Text style={styles.small}>
                    SAVINGS REMAINDER AT THE END OF 20 YEARS
                  </Text>
                </View>
              </View>
              <View style={styles.textHeading}>
                <Text>SAVINGS DEPLETION</Text>
                <Text style={{ fontSize: "10" }}>
                  SELECTED PORTFOLIO -{fundName}({rate.toFixed(2)}%)
                </Text>
              </View>
              <View>
                <IMG source={values[0]}></IMG>
              </View>
              {/* table data */}
              <View>
                <PDFTable
                  data={this.state.dec_pdfTable}
                  heading={this.state.dec_columns}
                  Width={"12.5%"}
                />
              </View>
            </View>
          </Page>

          {selectedPlan === "decumulation" && id !== 999 ? (
            <Fragment>
              <Page size="A4" wrap style={styles.page}>
                <View style={styles.paddingHorizontal}>
                  <View style={styles.text}>
                    <Text>HOLDINGS AND ASSET CLASS EXPOSURE</Text>
                  </View>
                  <View>
                    <IMG source={values[1]}></IMG>
                  </View>
                  {this.state.newData.length ? (
                    <View>
                      <PDFTable
                        data={this.state.newData}
                        heading={this.state.columns}
                        Width={"25%"}
                      />
                    </View>
                  ) : null}
                </View>
              </Page>

              <Page size="A4" wrap style={styles.page}>
                <View style={styles.paddingHorizontal}>
                  <View style={styles.text}>
                    <Text>PORTFOLIO GROWTH</Text>
                  </View>
                  <View>
                    <IMG source={values[2]}></IMG>
                  </View>
                </View>
              </Page>
            </Fragment>
          ) : null}
          {selectedPlan === "accumulation" && id !== 999 ? (
            <Fragment>
              <Page size="A4" wrap style={styles.page}>
                <View style={styles.paddingHorizontal}>
                  <View style={styles.text}>
                    <Text>HOLDINGS AND ASSET CLASS EXPOSURE</Text>
                  </View>
                  <View>
                    <IMG source={values[2]}></IMG>
                  </View>
                  {this.state.newData.length ? (
                    <View>
                      <PDFTable
                        data={this.state.newData}
                        heading={this.state.columns}
                        Width={"25%"}
                      />
                    </View>
                  ) : null}
                </View>
              </Page>
              <Page size="A4" wrap style={styles.page}>
                <View style={styles.paddingHorizontal}>
                  <View style={styles.text}>
                    <Text>PORTFOLIO GROWTH</Text>
                  </View>
                  <View>
                    <IMG source={values[3]}></IMG>
                  </View>
                </View>
              </Page>
            </Fragment>
          ) : null}
        </Document>
      );

      pdf(<MyDoc />)
        .toBlob()
        .then(blob => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "sample.pdf";
          document.body.append(link);
          link.click();
          link.remove();
        })
        .then(() => this.setState({ downloadPDF: false }));
    });
  };

  render() {
    const {
      spinner,
      getBacktest,
      getPerfHistMetrics,
      getRiskStatistics,
      acc_data,
      depletionFinalValue,
      investMentGlidePath,
      groupBarWithLineLabels
    } = this.state;
    const { id, selectedPlan } = this.props;

    return (
      <Fragment>
        <WithCard>
          <div style={{ display: "flex" }}>
            <Button
              exportPDF={this.exportPDF}
              marginLeft={"auto"}
              spinner={this.state.downloadPDF}
            />
          </div>
        </WithCard>
        {selectedPlan === "accumulation" ? (
          <Fragment>
            <h4 className="bold solution_heading">ACCUMULATION</h4>
            <WithCard>
              <Details AccumulationDetails={true} />
            </WithCard>
            {spinner === false ? (
              <WithCard>
                <BarChartHolder
                  getBacktest={getBacktest}
                  display={"accumulation"}
                  acc_data={acc_data}
                  investMentGlidePath={investMentGlidePath}
                  groupBarWithLineLabels={groupBarWithLineLabels}
                />
              </WithCard>
            ) : null}
          </Fragment>
        ) : null}
        <h4 className="bold solution_heading">DECUMULATION</h4>

        <WithCard>
          <Details depletionFinalValue={depletionFinalValue} />
        </WithCard>
        {spinner === false ? (
          <Fragment>
            <WithCard>
              <BarChartHolder
                getBacktest={getBacktest}
                display={"decumulation"}
              />
            </WithCard>
            {id !== 999 ? (
              <Fragment>
                <WithCard>
                  <PieHolder getBacktest={getBacktest} />
                </WithCard>
                <WithCard>
                  <LineChartHolder
                    getBacktest={getBacktest}
                    getPerfHistMetrics={getPerfHistMetrics}
                    getRiskStatistics={getRiskStatistics}
                  />
                </WithCard>
              </Fragment>
            ) : null}
          </Fragment>
        ) : (
          <WithCard>
            <Spinner />
          </WithCard>
        )}
      </Fragment>
    );
  }
}
export default connect(
  ({
    retirement: {
      rig: {
        intro: { selectedPlan },
        equation: {
          savings,
          income,
          donut: { shortfall, rate },
          fundSelected: { id },
          dec_pdfTable,
          retirementAccount,
          dec_barchartData,
          fundSelected: { fundName }
        },
        accumulation: {
          retirementAge,
          currentAge,
          currentSavings,
          possibleAnnualSavings,
          annualIncomeNeeded,
          socialSecurity,
          acc_otherIncome,
          acc_selectedPortfolio,
          possibleAnnualIRA,
          activeGlidePath,
          acc_fundSelected: { acc_fundName },
          fundList
        }
      }
    }
  }) => ({
    selectedPlan,
    savings,
    income,
    shortfall,
    rate,
    fundName,
    id,
    currentSavings,
    possibleAnnualSavings,
    annualIncomeNeeded,
    socialSecurity,
    acc_otherIncome,
    acc_selectedPortfolio,
    dec_pdfTable,
    possibleAnnualIRA,
    retirementAccount,
    retirementAge,
    currentAge,
    dec_barchartData,
    activeGlidePath,
    acc_fundName,
    fundList
  }),
  dispatch => ({
    donutHandler: (name, value) =>
      dispatch({ type: "RETIREMENT_DONUT_HANDLER", payload: { name, value } })
  })
)(Solution);

// annual addition
// reminder



// WEBPACK FOOTER //
// ./src/components/pages/Retire/Solution.jsx